module.exports = __webpack_public_path__ + "static/media/Workday_Step2b_Image7n.0c015fc9.jpg";